import type { FC } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import DownloadRounded from '@mui/icons-material/DownloadRounded';
import { Button } from '@mui/material';

import type { DetailedFollowUpTicket } from 'src/types/followUp';

const FeedbackDownloadButton: FC<{ ticket: DetailedFollowUpTicket }> = ({
  ticket,
}) => {
  const { t } = useTranslation(['followUp', 'downloadManager']);

  return (
    <Button
      variant="cta"
      color="secondary"
      startIcon={<DownloadRounded />}
      disabled={!ticket?.interviewUrl}
      href={ticket?.interviewUrl}
      role="button"
    >
      {t('common:download')}
    </Button>
  );
};

export default FeedbackDownloadButton;
